/**
 * emulates Object.groupBy, which isn't available in all supported browsers
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/groupBy
 *
 * @param array
 * @param groupingFunc
 * @returns
 */
function groupBy(array, groupingFunc) {
    return array.reduce((acc, curr) => {
        const prop = groupingFunc(curr);
        if (acc[prop]) {
            acc[prop].push(curr);
        }
        else {
            acc[prop] = [curr];
        }
        return acc;
    }, {});
}
export default groupBy;
